import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { } from '@aws-amplify/ui-angular';
import { S3UrlService } from 'src/app/shared/services/s3-url.service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { ComplianceDialogComponent } from './compliance-dialog/compliance-dialog.component';
import { PagadorService } from 'src/app/dashboard/services/pagador.service';
import { Pagador } from 'src/app/dashboard/interfaces/pagador';
import { VariablesComplianceService } from 'src/app/dashboard/services/variables-compliance.service';
import { UserService } from 'src/app/dashboard/services/user.service';
import { EstadoCompliance } from 'src/app/dashboard/interfaces/estado-compliance';
import { ComentarioCompliance } from 'src/app/dashboard/interfaces/comentario-compliance';
import { CreatePayerComponent } from 'src/app/dashboard/components/payer/create-payer/create-payer.component';
import { CompanyRegistrationService } from 'src/app/auth/services/company-registration.service';

export interface Image {
  key: string;
  url: string;
}

@Component({
  selector: 'app-compliance-user-ac',
  templateUrl: './compliance-user-ac.component.html',
  styleUrls: ['./compliance-user-ac.component.sass']
})
export class ComplianceUserAcComponent implements OnInit {
  images: Image[] = [];
  id: string = '';
  user: any;
  userEmail: string = '';
  fotoIdFrontal: string = '';
  fotoIdPosterior: string = '';
  mostarFrontal: boolean = true;
  idImagesLoaded: boolean = false;
  comentariosCompliance: ComentarioCompliance[] = [];
  estadosCompliance: EstadoCompliance[] = [];
  formCompliance: FormGroup | undefined;
  estadoComplianceBase: Object = {};
  pagadores: Pagador[] = [];
  isCompany = false;
  estatuto = '';
  documentoIdTributario = '';
  constructor(
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private varCompliance: VariablesComplianceService,
    private http: HttpClient,
    private _Activatedroute: ActivatedRoute,
    private cognito: CognitoService,
    private userService: UserService,
    private pagadorService: PagadorService,
    private dialog: MatDialog,
    private companyRegistrationService: CompanyRegistrationService,
    private s3UrlService: S3UrlService,
  ) {
    this.loadUserEmail();
    this.getVariablesCompliance();
    this.id = this._Activatedroute.snapshot.paramMap.get('email') ?? '';
    this.loadUser();
  }

  reloadPagadores() {
    this.pagadorService.getPagadoresByUser(this.user.usuarioId).then(res => {
      this.pagadores = res;
    })
  }

  async loadUser() {
    await this.userService.getUserData(this.id).subscribe(async ({ user }: any) => {
      this.user = user;
      this.isCompany = Boolean(this.user.tipoUsuarioID);
      this.pagadorService.getPagadoresByUser(this.user.usuarioId).then(res => {
        this.pagadores = res;
      })
      this.formCompliance = this.fb.group({
        esListaONU: new FormControl(
          {
            value: this.user.esListaONU,
            disabled: this.user.fuenteComplianceID === 2,
          },
          [Validators.required]
        ),
        politicamenteExpuesto: new FormControl(
          {
            value: this.user.esPoliticamenteExpuesto,
            disabled: this.user.fuenteComplianceID === 2,
          },
          [Validators.required]
        ),
        esRTP: new FormControl(
          {
            value: this.user.esRTP,
            disabled: this.user.fuenteComplianceID === 2,
          },
          [Validators.required]
        ),
      });
      this.getIdImages();
    });
  }
  async loadUserEmail() {
    const userInSession = await this.cognito.getUser();
    this.userEmail = userInSession.attributes.email;
  }

  async getVariablesCompliance() {
    [this.comentariosCompliance, this.estadosCompliance] = await Promise.all([
      this.varCompliance.getComentariosCompliance(),
      this.varCompliance.getEstadosCompliance(),
    ]);
  }

  async getIdImages() {
    this.idImagesLoaded = false;
    // Post-VULN-01: backend firma vía `s3UrlService.getReadUrl()`.
    const signed = async (key: string | null | undefined): Promise<string> =>
      (await this.s3UrlService.getReadUrl(key)) ?? '';

    // Para empresas: cargar desde companyRegistration data4 con fallback a campos usuario
    if (this.isCompany) {
      if (this.user.estatuto) {
        this.estatuto = await signed(this.user.estatuto);
      }
      if (this.user.documentoIdTributario) {
        this.documentoIdTributario = await signed(this.user.documentoIdTributario);
      }

      // Helper: intenta cargar un documento probando múltiples keys en orden
      const tryLoadDocument = async (...keys: (string | undefined | null)[]): Promise<string> => {
        const tried = new Set<string>();
        for (const key of keys) {
          if (!key || key === 'from_step1' || key === 'from_step1_selfie' || tried.has(key)) continue;
          tried.add(key);
          try {
            const res = await this.companyRegistrationService.getDocument(key);
            if (res?.url) return res.url;
          } catch {}
        }
        return '';
      };

      let data4: any = null;
      let data5: any = null;
      try {
        const companyRegistration = await this.companyRegistrationService.getRegistration(this.user.usuarioId);
        data4 = companyRegistration?.data?.companyDocuments?.data4;
        data5 = companyRegistration?.data?.companyDocuments?.data5;
      } catch (err) {
      }

      const repLegal = data5?.representantes?.[0];

      // Documento frontal: data4 -> representante legal (data5) -> user
      this.fotoIdFrontal = await tryLoadDocument(
        data4?.documento_frontal, repLegal?.documento_frontal, this.user.fotoIdfrontal
      );
      // Documento reverso: data4 -> representante legal (data5) -> user
      this.fotoIdPosterior = await tryLoadDocument(
        data4?.documento_reverso, repLegal?.documento_reverso, this.user.fotoIdPosterior
      );
      this.idImagesLoaded = true;
      return;
    }

    // Para personas: cargar fotos como data: inline para mostrar en <img>.
    if (this.user.fotoIdfrontal) {
      const signedUrl = await signed(this.user.fotoIdfrontal);
      if (signedUrl) {
        this.http.get(signedUrl, { responseType: 'blob' }).subscribe(
          (response) => {
            const reader = new FileReader();
            reader.readAsDataURL(response);
            reader.onloadend = () => { this.fotoIdFrontal = reader.result as string; };
          },
          () => {}
        );
      }
    }

    if (this.user.fotoIdPosterior) {
      const signedUrl = await signed(this.user.fotoIdPosterior);
      if (signedUrl) {
        this.http.get(signedUrl, { responseType: 'blob' }).subscribe(
          (response) => {
            const reader = new FileReader();
            reader.readAsDataURL(response);
            reader.onloadend = () => { this.fotoIdPosterior = reader.result as string; };
          },
          () => {}
        );
      }
    }
    this.idImagesLoaded = true;
  }

  openTab(url: string) {
    window.open(url, "_blank");
  }

  async ngOnInit() { }

  aproveCompliance() {
    const ref = this.spinner.start();
    this.userService
      .updateUserCompliance(
        this.user.email,
        this.userEmail,
        {
          comentarioCompliance: 0,
          estadoCompliance: 3
        }
      )
      .subscribe(
        (res) => {
          this.loadUser();
          Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha aprobado el usuario con éxito',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',

          });
          this.spinner.stop(ref);
        },
        (err) => this.spinner.stop(ref)
      );
  }

  backlistUser() {
    const ref = this.spinner.start();
    this.userService
      .updateUserCompliance(
        this.user.email,
        this.userEmail,
        {
          comentarioCompliance: 0,
          estadoCompliance: 2
        }
      )
      .subscribe(
        (res) => {
          this.loadUser();
          Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha marcado el usuario como blacklist',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',

          });
          this.spinner.stop(ref);
        },
        (err) => this.spinner.stop(ref)
      );
  }
  rejectUser() {
    this.dialog.open(ComplianceDialogComponent, {
      data: {
        userEmail: this.userEmail,
        user: this.user,
        comentariosCompliance: this.comentariosCompliance
      }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.loadUser();
      }
    })
  }
  guardarCompliance() {
    if (this.formCompliance?.invalid || !this.formCompliance?.touched) {
      return;
    }
    const ref = this.spinner.start();
    this.userService
      .updateUserChecks(
        this.user.email,
        this.userEmail,
        this.formCompliance.value
      )
      .subscribe(
        (res) => {
          Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha actualizado la información de compliance del usuario',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',

          });
          this.loadUser();
          this.spinner.stop(ref);
        },
        (err) => this.spinner.stop(ref)
      );
  }

  openAddPayer() {
    this.dialog.open(CreatePayerComponent, {
      data: { email: this.id, id: this.user.usuarioId },
      height: '80%',
      width: '90%',
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.reloadPagadores();
      }
    });
  }
}
